module.exports = __webpack_public_path__ + "static/media/upload-media.710317fc.svg";